import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.querySelectorAll('.quicklinks-carousel').forEach($el => {
    new Swiper($el, {
        slidesPerView: 1.5,
        spaceBetween: 8,
        loop: false,
        breakpoints: {
            768: { slidesPerView: 2.5 },
            1280: { slidesPerView: 4 },
        },
        navigation: {
            prevEl: $el.closest('.swiper-container').querySelector('.prev-slide'),
            nextEl: $el.closest('.swiper-container').querySelector('.next-slide'),
        },
    });
});

document.querySelectorAll('.features-carousel').forEach($el => {
    new Swiper($el, {
        slidesPerView: 'auto',
        spaceBetween: 32,
        loop: false,
        centeredSlides: true,
        initialSlide: 1,
        allowTouchMove: true,
        breakpoints: {
            600: {
                spaceBetween: 80,
                allowTouchMove: true,
            },
            1280: {
                allowTouchMove: false,
            },
        },
        on: {
            breakpoint(swiper) {
                if (window.innerWidth >= 1280) {
                    swiper.slideTo(1);
                }
            },
        },
        navigation: {
            prevEl: $el.closest('.swiper-container').querySelector('.prev-slide'),
            nextEl: $el.closest('.swiper-container').querySelector('.next-slide'),
        },
    });
});

document.querySelectorAll('.latest-carousel').forEach($el => {
    const swiper = new Swiper($el, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        loop: true,
        navigation: {
            prevEl: $el.closest('.swiper-container').querySelector('.prev-slide'),
            nextEl: $el.closest('.swiper-container').querySelector('.next-slide'),
        },
        on: {
            init() {
                updateIndex(this);
            },
            slideChange() {
                updateIndex(this);
            },
        },
    });

    function updateIndex(swiper) {
        swiper.el.style.setProperty('--current-index', swiper.activeIndex);
    }
});

document.querySelectorAll('.testimonial-carousel').forEach($el => {
    new Swiper($el, {
        slidesPerView: 1.25,
        spaceBetween: 16,
        breakpoints: {
            640: {
                slidesPerView: 2.5,
                spaceBetween: 16,
            },
            1280: {
                slidesPerView: 3,
            },
        },
        navigation: {
            prevEl: $el.closest('.swiper-container').querySelector('.prev-slide'),
            nextEl: $el.closest('.swiper-container').querySelector('.next-slide'),
        },
    });
});

new Swiper('.default-carousel', {
    slidesPerView: 1.25,
    spaceBetween: 24,
    loop: true,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
            spaceBetween: 48,
        },
        1024: {
            slidesPerView: 2.25,
        },
        1280: {
            slidesPerView: 2.5,
            spaceBetween: 64,
        },
    },
    navigation: {
        prevEl: '.prev-slide',
        nextEl: '.next-slide',
    },
});

new Swiper('.image-carousel', {
    slidesPerView: 1.25,
    spaceBetween: 16,
    loop: true,
    centeredSlides: true,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
        },
    },
    navigation: {
        prevEl: '.prev-slide',
        nextEl: '.next-slide',
    },
});
